import {COLORS} from 'src/v2/util/color';

type CountdownRingProps = {
  seconds: number;
  total: number;
  size?: number;
  strokeWidth?: number;
};

export const CountdownRing = ({
  seconds,
  total,
  size = 20,
  strokeWidth = 2,
}: CountdownRingProps) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = seconds / total;
  const offset = circumference * (1 - progress);

  return (
    <svg width={size} height={size} style={{flexShrink: 0}}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={COLORS.backgroundNeutral}
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="rgba(0, 163, 85, 1)"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{transition: 'stroke-dashoffset 1s linear'}}
      />
    </svg>
  );
};
